<span class="animated infinite inbox-icon" [class.tada3rd]="messageDropdown.total > 0">
  <i class="material-symbols-rounded">{{ messageDropdown.total > 0 ? 'notifications' : 'notifications_none' }}</i>
  <span class="badge badge-danger badge-sup" *ngIf="messageDropdown.total > 0">
    {{ messageDropdown.total > 99 ? '99+' : messageDropdown.total }}
  </span>
</span>
